import { Sender } from "xstate";
import { SocketEvent } from "@iventis/types/loading.types";
import { onSocketMessages } from "@iventis/api/src/connection.slice";
import { ScheduleMachineEvent } from "./schedule.machine.types";

/** Subscribes to web socket messages and sends appropriate events to the machine in which it is invoked */
export const scheduleWebSocketSub = (send: Sender<ScheduleMachineEvent>) => {
    const messageStream = onSocketMessages(SocketEvent.SCHEDULE_VERSION_COPIED, SocketEvent.NODE_CREATED);

    const subscription = messageStream.subscribe((event) => {
        switch (event.eventName) {
            case SocketEvent.SCHEDULE_VERSION_COPIED:
                send({ type: "SCHEDULE_VERSION_CHILD_COPIED", payload: event.message.newEntity });
                break;
            case SocketEvent.NODE_CREATED:
                send({ type: "SCHEDULE_VERSION_NODE_CREATED", payload: event.message });
                break;
            default:
                throw new Error("Websocket event is not handled");
        }
    });

    return subscription;
};
